import React from 'react';
import { useAppSelector, useAppDispatch } from '../../store';
import { closeModal } from '../../store/slices/uiSlice';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import styles from './ConfirmationModal.module.scss';

const ConfirmationModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const modal = useAppSelector((state) => state.ui.modal);

  if (!modal.isOpen) return null;

  const handleClose = () => {
    if (modal.onCancel) {
      modal.onCancel();
    } else {
      dispatch(closeModal());
    }
  };

  const handleConfirm = () => {
    if (modal.onConfirm) {
      modal.onConfirm();
    }
    dispatch(closeModal());
  };

  return (
    <Modal
      isOpen={modal.isOpen}
      onClose={handleClose}
      title={modal.headerText}
      large={modal.large}
      footer={
        <div className={styles.footer}>
          {modal.cancelText && (
            <Button variant="secondary" onClick={handleClose}>
              {modal.cancelText}
            </Button>
          )}
          {modal.confirmText && (
            <Button variant="primary" onClick={handleConfirm}>
              {modal.confirmText}
            </Button>
          )}
        </div>
      }
    >
      {modal.body}
    </Modal>
  );
};

export default ConfirmationModal;
